import {
  parseViewBackedAppResourceId as parseSharedViewBackedAppResourceId,
  viewBackedAppResourceId as sharedViewBackedAppResourceId,
} from '@streamlain/database-identity';

import type { ViewBackedAppDescriptor } from './types';

export function viewBackedAppResourceId(
  descriptor: Pick<ViewBackedAppDescriptor, 'appKind' | 'resourcePrefix'>,
  docId: string,
  databaseId: string,
  viewId: string | null | undefined
): string {
  return sharedViewBackedAppResourceId(descriptor, docId, databaseId, viewId);
}

export function parseViewBackedAppResourceId(
  descriptor: Pick<ViewBackedAppDescriptor, 'appKind' | 'resourcePrefix'>,
  resourceId: string
): {
  docId: string;
  databaseId: string;
  viewId: string;
} {
  return parseSharedViewBackedAppResourceId(descriptor, resourceId);
}
